import { render, staticRenderFns } from "./Merchandise.vue?vue&type=template&id=8ea64d6a"
import script from "./Merchandise.vue?vue&type=script&lang=js"
export * from "./Merchandise.vue?vue&type=script&lang=js"
import style0 from "./Merchandise.vue?vue&type=style&index=0&id=8ea64d6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports